'use strict';
var ansiRegex = require('ansi-regex')();

module.exports = function (str) {
	return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
};



//////////////////
// WEBPACK FOOTER
// ./~/react-dev-utils/~/strip-ansi/index.js
// module id = 67
// module chunks = 0